import {z} from '@hono/zod-openapi';

/** How a fact plays for one side of the deal: argument (pro), objection (contra) or unused. */
export const priceReportArgumentDirectionSchema = z
  .enum(['pro', 'contra', 'neutral'])
  .openapi('PriceReportArgumentDirection');

export type PriceReportArgumentDirection = z.infer<typeof priceReportArgumentDirectionSchema>;
